import {IPreviewTextVariant} from "../interfaces/preview-text-variant.interface";

export const defaultPreviewTexts: IPreviewTextVariant = {
    sidebar_athletes: '',
    sidebar_athletes_link: '',
    athletes_title: '',
    create_athlete_button_label: "",
    reached_athletes_limit: "",
    save_athlete_link: '',
    remove_selected_athletes: "",
    no_athletes: "",
    no_athletes_description: "",
    athletes_page_link: '',
    most_active_athletes: '',
    sidebar_workouts: '',
    sidebar_workouts_link: '',
    workouts_title: "",
    deleted_workouts: "",
    push_workouts_to_locaitons: '',
    create_workout_link: '',
    this_workout_is_empty: "",
    restore_deleted_workouts: "",
    go_to_workouts: '',
    no_deleted_workouts: "",
    create_workout_title: "",
    add_new_playlist_to_workout: "",
    edit_workout_title: "",
    push_workouts_success: "",
    push_workouts_error: "",
    workout_created_success: "",
    workout_edited_success: "",
    get_workout_error: "",
    delete_workout_confirm_text: "",
    athlete_updated_success: "",
    athlete_created_success: "",
    atheletes_bulk_import_error: "",
    most_active_exercise_athelete_name: "",
    athlete_bulk_import_template: "",
    remaining_athletes: "",
    restore_workout_confirm_text: "",
    workout_title: ""
}
